<template>
  <div>
    <v-card
      @click="$emit('display', { id: 0 })"
      class="card ma-2 pl-3"
      :color="displayedTechId === 0 ? 'lightgrey' : 'opposite'"
      id="techCard-0"
      outlined
    >
      <custom-light-card
        icon="mdi-map-marker"
        :specificTitleClasses="isPropertyOrdo ? 'success--text' : ''"
        :subtitle="request.propertyAdress"
        :title="request.property_shortname"
      />
    </v-card>
    <v-card
      @click="$emit('display', item)"
      class="card ma-2 pl-3 pb-3"
      :color="displayedTechId === item.id ? 'lightgrey' : 'opposite'"
      :id="`techCard-${item.id}`"
      :key="item.num"
      outlined
      v-for="item in orderedTechnicians"
    >
      <custom-light-card
        :alert="getAlertMessage(item)"
        :icon="item.specific_position.icon"
        specificAlertClasses="font-weight-light font-italic"
        :specificTitleClasses="
          item.absence_today
            ? 'warning--text'
            : item.scheduled
            ? 'success--text'
            : ''
        "
        :specificSubtitleClasses="getSpecificSubtitleClasses(item)"
        :status="item.specific_status"
        :subtitle="
          item.roles.length > 1 ? item.roles : item.specific_position.position
        "
        :title="item.full_name"
        :chip="{ title: item.absence_today, subtitle: item.hours_of_absence }"
      />
    </v-card>
  </div>
</template>

<script>
import CustomLightCard from '@/components/cards/CustomLightCard';
import { generateMessage } from '@/utils/i18n';
import getPosition, {
  getPositions,
} from '@/components/selects/technician/technicianPosition';
import getStatus from '@/components/selects/technician/technicianStatus';
import { mapGetters } from 'vuex';

export default {
  name: 'TechnicianCardsList',
  components: {
    CustomLightCard,
  },
  props: {
    displayedTechId: { type: Number, required: false, default: -1 },
    isPropertyOrdo: { type: Boolean, required: false },
    request: { type: Object, required: true },
    specialTechnicians: { type: Object, required: true },
    technicians: { type: Array, required: true },
  },
  computed: {
    ...mapGetters({
      isDarkThemeEnabled: 'boilerplate/darkThemeEnabled',
    }),
    orderedTechnicians() {
      return this.technicians
        .map((item) => ({
          ...item,
          specific_position: getPosition(item.id, this.specialTechnicians),
          specific_status: getStatus(item),
          roles: getPositions(item.id, this.specialTechnicians).map(
            (item) => `${item.position}`
          ),
        }))
        .sort((a, b) => a.specific_position.id - b.specific_position.id);
    },
  },
  methods: {
    generateMessage,
    getPositions,
    getAlertMessage(item) {
      return item.specific_status.icon &&
        !(item.intervention_longitude && item.intervention_latitude)
        ? this.generateMessage('tech_search.cardView.nodata')
        : '';
    },
    getSpecificSubtitleClasses(item) {
      if (
        item.specific_position.position ===
          this.generateMessage('tech_search.positions.on_call') ||
        item.specific_position.position ===
          this.generateMessage('tech_search.positions.on_call_end')
      )
        return this.isDarkThemeEnabled
          ? 'white--text font-weight-bold'
          : 'black--text font-weight-bold';
      return '';
    },
  },
};
</script>

<style scoped>
.theme--dark .card:hover {
  border-color: #008cd0 !important;
}
.theme--light .card:hover {
  border-color: #039be5 !important;
}
</style>
